import { Regua } from './../../models/regua.model';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReguaService {

  baseUrlAdmin = environment.baseUrlAdmin;

  constructor(private http: HttpClient, private toastr: ToastrService) {}

  public create(regua: any): Observable<Regua> {
    const service = 'reguas';
    return this.http.post<Regua>(this.baseUrlAdmin + service, regua);
  }

  public read(): Observable<Regua[]> {
    const service = 'reguas';
    return this.http.get<Regua[]>(this.baseUrlAdmin + service);
  }

  public readById(id: string): Observable<Regua> {
    const service = `${'reguas'}/${id}`;
    return this.http.get<Regua>(this.baseUrlAdmin + service);
  }

  public update(regua: any, id: any): Observable<Regua> {
    const service = `${'reguas'}/${id}`;
    return this.http.put<Regua>(this.baseUrlAdmin + service, regua);
  }

  public delete(id: string): Observable<Regua> {
    const service = `${'reguas'}/${id}`;
    return this.http.delete<Regua>(this.baseUrlAdmin + service);
  }

  public toastSuccess(msg: string) {
    return this.toastr.success(msg);
  }

  public toastError(msg: string) {
    return this.toastr.error(msg);
  }
}
